import React, { useState, useEffect } from 'react'
import { MdClose } from 'react-icons/md'
import { Snippet, Button, Avatar } from '@nextui-org/react'
import { getProjectsRequests, postProjectsRequestApprove, postProjectsRequestReject } from '../../../services/projects'
import Notiflix from 'notiflix'

function RequestPopupComponent(props) {
  const [isOpen, setIsOpen] = useState(true)
  const [requests, setRequests] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // Proje slug'ını al
  const projectSlug = props.projectSlug || 'proje-slug'

  // İstekleri yükle
  useEffect(() => {
    const fetchRequests = async () => {
      if (!projectSlug || projectSlug === 'proje-slug') return

      try {
        setLoading(true)
        setError(null)
        const response = await getProjectsRequests({ slug: projectSlug })
        setRequests(response.requests || [])
      } catch (err) {
        console.error('İstekler yüklenirken hata:', err)
        setError('İstekler yüklenirken bir hata oluştu')
      } finally {
        setLoading(false)
      }
    }

    fetchRequests()
  }, [projectSlug])

  const handleClose = () => {
    setIsOpen(false)
    props.closePopup(false)
  }

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      // Eğer overlay alanına tıklanırsa kapat
      setIsOpen(false)
      props.closePopup(false)
    }
  }

  // İsteği onayla
  const handleApprove = async (requestId) => {
    try {
      Notiflix.Loading.pulse('İstek onaylanıyor...')

      await postProjectsRequestApprove({ requestId: parseInt(requestId) })

      Notiflix.Loading.remove()
      Notiflix.Notify.success('İstek başarıyla onaylandı!')

      // İstekleri yenile
      const response = await getProjectsRequests({ slug: projectSlug })
      setRequests(response.requests || [])
    } catch (error) {
      Notiflix.Loading.remove()
      Notiflix.Notify.failure('İstek onaylanırken hata oluştu!')
      console.error('Onaylama hatası:', error)
    }
  }

  // İsteği reddet
  const handleReject = async (requestId) => {
    try {
      Notiflix.Loading.pulse('İstek reddediliyor...')

      await postProjectsRequestReject({ requestId: parseInt(requestId) })

      Notiflix.Loading.remove()
      Notiflix.Notify.success('İstek başarıyla reddedildi!')

      // İstekleri yenile
      const response = await getProjectsRequests({ slug: projectSlug })
      setRequests(response.requests || [])
    } catch (error) {
      Notiflix.Loading.remove()
      Notiflix.Notify.failure('İstek reddedilirken hata oluştu!')
      console.error('Reddetme hatası:', error)
    }
  }

  return (
    <>
      {props.show && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" onClick={handleBackgroundClick}>
          <div className="bg-white dark:bg-gray-800 w-[900px] max-h-[600px] rounded-lg shadow-lg">
            {/* Header */}
            <div className="flex justify-between items-center border-b border-gray-200 dark:border-gray-700 p-6">
              <h1 className="font-semibold text-lg text-gray-900 dark:text-white">Kullanıcı İstekleri</h1>
              <button onClick={handleClose} className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors">
                <MdClose className="text-gray-500 dark:text-gray-400 text-xl" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 max-h-[450px] overflow-y-auto">
              {/* Bilgilendirme Mesajı */}
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/10 dark:to-indigo-900/10 border border-blue-200/50 dark:border-blue-700/30 rounded-xl p-4 mb-2">
                <div className="flex items-center space-x-3">
                  <div className="flex-shrink-0">
                    <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                  </div>
                  <div className="flex-1">
                    <p className="text-sm text-blue-700 dark:text-blue-300 leading-relaxed">
                      Bu uzantıyı kopyalayarak ekip arkadaşlarınızı projeye davet edebilirsiniz
                    </p>
                  </div>
                </div>
              </div>
              {/* Proje Bilgisi */}
              <div className="bg-gray-100 dark:bg-gray-700 w-full rounded-md flex items-center justify-center p-3 mb-6">
                <Snippet symbol="#" color="">
                  {projectSlug}
                </Snippet>
              </div>

              {/* Loading State */}
              {loading && (
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                  <p className="mt-4 text-gray-600 dark:text-gray-400">İstekler yükleniyor...</p>
                </div>
              )}

              {/* Error State */}
              {error && (
                <div className="text-center py-8">
                  <p className="text-red-600 dark:text-red-400 mb-4">{error}</p>
                  <Button onClick={() => window.location.reload()} color="primary" size="sm">
                    Tekrar Dene
                  </Button>
                </div>
              )}

              {/* İstekler Listesi */}
              {!loading && !error && requests.length > 0 && (
                <div className="space-y-4">
                  {requests.map((request, index) => (
                    <div key={request.id || index} className="bg-gray-50 dark:bg-gray-700 rounded-lg p-4 border border-gray-200 dark:border-gray-600">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center space-x-3">
                          {/* Kullanıcı Avatar */}
                          <Avatar src={request.user_image ? `${process.env.NEXT_PUBLIC_USERIMG}${request.user_image}` : null} name={request.user_fname[0]} className="h-10 w-10" />

                          {/* Kullanıcı Bilgileri */}
                          <div>
                            <h3 className="font-medium text-gray-900 dark:text-white">{request.user_fname || 'Bilinmeyen Kullanıcı'}</h3>
                            <p className="text-xs text-gray-400 dark:text-gray-500">
                              İstek Tarihi: {request.request_date ? new Date(request.request_date).toLocaleDateString('tr-TR') : 'Bilinmiyor'}
                            </p>
                          </div>
                        </div>

                        {/* Aksiyon Butonları */}
                        <div className="flex space-x-2">
                          <Button color="success" size="sm" onClick={() => handleApprove(request.request_id)} className="bg-green-600 hover:bg-green-700 text-white">
                            Onayla
                          </Button>
                          <Button color="danger" size="sm" onClick={() => handleReject(request.request_id)} className="bg-red-600 hover:bg-red-700 text-white">
                            Reddet
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Empty State */}
              {!loading && !error && requests.length === 0 && (
                <div className="text-center py-12">
                  <img className="w-48 mx-auto mb-4" src="/assets/dashboard/aktifp.svg" alt="" />
                  <p className="text-gray-500 dark:text-gray-400 text-sm">Projenize gelen herhangi bir istek bulunamadı.</p>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="border-t border-gray-200 dark:border-gray-700 p-6">
              <div className="flex justify-end">
                <Button onClick={handleClose} variant="ghost" className="text-gray-600 dark:text-gray-400">
                  Kapat
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default RequestPopupComponent
